import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export class CollectionFavoriteStateChannel extends MicroviewCommunicationChannel<{ id: string }, Promise<boolean>> {
  public name: string = 'CollectionFavoriteStateChannel';
  public namespace: string = 'SearchMicroview.CollectionFavoriteStateChannel';
}
